import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ApprovalProvider } from '../unhcr/partnerInternalRequestApproval/ContextAPI';
import Index from '../unhcr/partnerInternalRequestApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function PartnerInternalRequestUnhcrApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['partner-internal-request-unhcr-approval']) return <PermissionDenied />;

    return (
        <ApprovalProvider>
            <Index />
        </ApprovalProvider>
    );
}
